import * as formik from 'formik';
import * as yup from 'yup';

import { Col, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from 'react';

import AppButton from '../../commons/buttons/AppButton';
import AppContainer from '../../commons/containers/AppContainer';
import AppCurrencyInput from '../../commons/inputs/AppCurrencyInput';
import AppInput from '../../commons/inputs/AppInput';
import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import AppTextAreaInput from '../../commons/inputs/AppTextAreaInput';
import HallAppToast from '../../commons/HallAppToast';
import ProductsAPI from './ProductsAPI';
import SelectBasicInput from '../../commons/inputs/SelectBasicInput';
import StockAPI from './StockAPI';

const unitis = [
    { key: 'UN', label: 'Unidade (UN)' },
    { key: 'ML', label: 'Mililitros (ML)' },
    { key: 'L', label: 'Litros (L)' },
    { key: 'G', label: 'Gramas (g)' },
    { key: 'KG', label: 'Quilogramas (KG)' },
    { key: 'MG', label: 'Miligramas (MG)' },
    { key: 'CL', label: 'Centilitros (CL)' },
    { key: 'DL', label: 'Decilitros (DL)' },
    { key: 'CM3', label: 'Centímetros cúbicos (CM³)' },
    { key: 'M3', label: 'Metros cúbicos (M³)' },
    { key: 'PC', label: 'Peças (PC)' },
    { key: 'DZ', label: 'Dúzia (DZ)' }
]

const optionsDetinations = [
    { key: 'SALE', label: 'Venda' },
    { key: 'CONSUMPTION', label: 'Consumo' }
]

const stockAPI = new StockAPI()
const productAPI = new ProductsAPI()

function ModalStock({ closeShow, show, productToEdit, callGetProducts }) {

    const [isLoading, setIsLoading] = useState(false)

    const [initialValues, setInitialValues] = useState({
        name: '',
        unityType: '',
        qtdStock: '',
        minStockNotify: '',
        destination: '',
        internalCode: '',
        barCode: '',
        line: '',
        category: '',
        mark: '',
        description: '',
        purchaseCost: '',
        salesValue: '',
        salesPercentage: '',
        commission: '',
    });

    const { Formik } = formik;

    const schema = yup.object().shape({
        name: yup.string().required('Informe um nome para o produto').max(100, 'Nome deve ter no maximo 100 cracteres'),
        unityType: yup.string(),
        qtdStock: yup.string().required('Informe a quantidade em estoque'),
        minStockNotify: yup.string(),
        destination: yup.string(),
        internalCode: yup.string(),
        barCode: yup.string(),
        line: yup.string(),
        category: yup.string(),
        mark: yup.string(),
        description: yup.string(),
        purchaseCost: yup.string(),
        salesValue: yup.string(),
        salesPercentage: yup.string(),
        commission: yup.string(),
    });

    useEffect(() => {
        if (productToEdit && Object.keys(productToEdit).length > 0) {

            setInitialValues({
                name: productToEdit.name || '',
                unityType: productToEdit.unityType || '',
                qtdStock: productToEdit.qtdStock || '',
                minStockNotify: productToEdit.minStockNotify || '',
                destination: productToEdit.destination || '',
                internalCode: productToEdit.internalCode || '',
                barCode: productToEdit.barCode || '',
                line: productToEdit.line || '',
                category: productToEdit.category || '',
                mark: productToEdit.mark || '',
                description: productToEdit.description || '',
                salesValue: productToEdit.salesValue || '',
                salesPercentage: productToEdit.salesPercentage || '',
                commission: productToEdit.commission || '',
                purchaseCost: productToEdit.purchaseCost || '',

            });
        }
    }, [productToEdit]);

    const save = async (values) => {
        const data = {
            ...values,
            unityType: values.unityType || 'UN',
            destination: values.destination || 'SALE'
        }

        setIsLoading(true)
        try {
            if (productToEdit?.id) {
                await stockAPI.updateProduct(productToEdit?.id, data);
            } else {
                await stockAPI.createProduct(data);
            }
            HallAppToast.success();
            if (callGetProducts) callGetProducts()
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false)
        }
    }

    // dentro do componente ModalStock, antes do return do JSX:
    const toNumber = (v) => {
        if (typeof v === "number") return v;
        if (v == null) return 0;
        return Number(String(v).replace(/[^\d,-.]/g, "").replace(".", "").replace(",", ".")) || 0;
    };

    const computeSale = (purchaseCost, salesPercentage) => {
        const cost = toNumber(purchaseCost);
        const pct = toNumber(salesPercentage);

        return Number((cost * (1 + pct / 100)).toFixed(2));
    };

    const applySale = (setFieldValue, purchaseCost, salesPercentage) => {
        const sale = computeSale(purchaseCost, salesPercentage);
        setFieldValue("salesValue", sale, false);
    };


    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className='custom-close-button' closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        ADICIONAR PRODUTO
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Formik
                        validationSchema={schema}
                        onSubmit={save}
                        initialValues={initialValues}
                        enableReinitialize={true}
                    >
                        {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <div className='container'>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <AppInput
                                                errors={errors}
                                                isRequired
                                                touched={touched}
                                                name="name"
                                                onChange={handleChange}
                                                value={values.name}
                                                type="text"
                                                label="Nome"
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <SelectBasicInput
                                                errors={errors}
                                                touched={touched}
                                                name='unityType'
                                                onChange={handleChange}
                                                value={values.unityType}
                                                options={unitis}
                                                label='Unidade de Medida'
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12} md={6}>
                                            <AppInput
                                                errors={errors}
                                                isRequired
                                                touched={touched}
                                                name="qtdStock"
                                                onChange={handleChange}
                                                value={values.qtdStock}
                                                type="number"
                                                label="Qtd. Estoque"
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='minStockNotify'
                                                onChange={handleChange}
                                                value={values.minStockNotify}
                                                type="number"
                                                label='Notificar a partir de'
                                                formText='Quando o estoque mínimo for atingido, você receberá uma notificação no WhatsApp da empresa.'
                                            />
                                        </Col>
                                    </Row>


                                    <SelectBasicInput
                                        errors={errors}
                                        touched={touched}
                                        name='destination'
                                        onChange={handleChange}
                                        value={values.destination}
                                        options={optionsDetinations}
                                        label='Destino'
                                    />

                                    <Row>
                                        <Col xs={12} md={6}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name="internalCode"
                                                onChange={handleChange}
                                                value={values.internalCode}
                                                type="text"
                                                label="Código interno"
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='barCode'
                                                onChange={handleChange}
                                                value={values.barCode}
                                                type="text"
                                                label='Código de barras'
                                            />
                                        </Col>
                                    </Row>


                                    <Row>
                                        <Col xs={12} md={4}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name="line"
                                                onChange={handleChange}
                                                value={values.line}
                                                type="text"
                                                label="Linha"
                                            />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='category'
                                                onChange={handleChange}
                                                value={values.category}
                                                type="text"
                                                label='Categoria'
                                            />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='mark'
                                                onChange={handleChange}
                                                value={values.mark}
                                                type="text"
                                                label='Marca'
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12} md={3}>
                                            <AppCurrencyInput
                                                errors={errors}
                                                touched={touched}
                                                name="purchaseCost"
                                                value={values.purchaseCost}
                                                type="text"
                                                label='Custo de Compra'
                                                onChange={(_, value) => {
                                                    setFieldValue("purchaseCost", value)
                                                    applySale(setFieldValue, value, values.salesPercentage);
                                                }} />

                                        </Col>
                                        <Col xs={12} md={3}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='salesPercentage'
                                                onChange={(e) => {
                                                    setFieldValue("salesPercentage", e.target.value);
                                                    applySale(setFieldValue, values.purchaseCost, e.target.value);
                                                }}
                                                value={values.salesPercentage}
                                                type="number"
                                                label='% de Venda'
                                                formText={'Qtos. % deseja receber em cima do custo de compra'}
                                            />
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <AppCurrencyInput
                                                errors={errors}
                                                disabled
                                                touched={touched}
                                                name='salesValue'
                                                value={values.salesValue}
                                                type="text"
                                                label='Preço de Venda'
                                            />
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <AppInput
                                                errors={errors}
                                                touched={touched}
                                                name='commission'
                                                onChange={handleChange}
                                                value={values.commission}
                                                type="number"
                                                label='% Comissão por venda'
                                            />
                                        </Col>
                                    </Row>

                                    <AppTextAreaInput
                                        errors={errors}
                                        touched={touched}
                                        name='description'
                                        onChange={handleChange}
                                        value={values.description}
                                        type="text"
                                        label='Descrição'
                                    />

                                    {isLoading ? <div style={{ textAlign: 'center' }}>
                                        <AppLoading />
                                    </div> :
                                        <AppButton type="submit" width='100%' name='salvar' />
                                    }
                                    <div style={{ marginTop: '10px' }}>
                                        <AppLinkButton name="fechar" onClick={closeShow} />
                                    </div>
                                </div>


                            </Form>
                        )}
                    </Formik>

                </Modal.Body>
            </Modal>
        </>
    );
}

export default ModalStock;